import { MenuItemType } from'./index'

const DISABLED: MenuItemType[] = (() => { 
    const disable = [
        { key:'disable', label:'Em breve', isTitle: true },
        {
            key:"operacional",
            label:"Operacional",
            icon:"fa-solid fa-gear",
            //url:'/operacional',
            children: [
                {
                key:'tasks',
                label:'Tarefas',
                //url:'/tasks',
                parentKey:'cadastros',
                disable: true,
                },
                {
                    key:'hireds',
                    label:'Contratados',
                    //url:'/hireds',
                    parentKey:'cadastros',
                    disable: true,
                },
            ]
        },
        {
            key:"atendimentos",
            label:"Atendimentos",
            icon:"fa-solid fa-headphones",
            children: [
                {
                    key:"documentos",
                    label:"Documentos",
                },
                {
                    key:"arquivos",
                    label:"Arquivos",
                },
                {
                    key:"comunicados",
                    label:"Comunicados",
                },
                {
                    key:"suporte",
                    label:"Suporte",
                },
                {
                    key:"protocolo",
                    label:"Protocolo",
                },
                {
                    key:"consultas",
                    label:"Consultas",
                }
            ]
        },
        {
            key:"comercial",
            label:"Comercial",
            icon:"fa-solid fa-chart-line",
            children: [
                {
                    key:"comercial_propostas",
                    label:"Propostas",
                },
                {
                    key:"comercial_services",
                    label:"Serviços",
                },
                {
                    key:"descricao",
                    label:"Descrição",
                }
            ]
        },
        {
            key:"orders",
            label:"Ordens de Serviço",
            icon:"fa-regular fa-clipboard",
            children: [
                {
                    key:"orders_OS",
                    label:"Ordens de Serviço",
                },
                {
                    key:"orders_services",
                    label:"Serviços",
                }
            ]
        },
        {
            key:"financeiro",
            label:"Financeiro",
            icon:"fa-solid fa-dollar-sign",
            //url:'/financeiro',
        },
        {
            key:"report",
            label:"Relatórios",
            icon:"fa-solid fa-chart-column",
            //url:'/report',
            children: [
                {
                    key:"irpf",
                    label:"IRPF",
                    //url:'/report/irpf',
                },
                {
                    key:"parcelamentos",
                    label:"Parcelamentos",
                    //url:'/report/parcelamentos',
                }
            ],
        },
        {
            key:"requerimentos",
            label:"Requerimentos",
            icon:"fa-solid fa-file-invoice-dollar",
            //url:'/requerimentos',
        },
        {
            key:'agendamentos',
            label:'Agendamentos',
            icon:"fa-solid fa-calendar-days",
            //url:'/agendamentos',
        },
        {
            key:'informacoes_diversas',
            label:"Informações diversas",
            icon:"fa-solid fa-circle-info",
            //url:'/informacoes_diversas',
        },
        {
            key:'main_config',
            label:"configurações",
            icon:"fa-solid fa-gear",
            url:'/settings',
        }
    ].map(item => ({ ...item, disable: true, badge: { variant:'secondary', text:'Em breve', onlyHouver: true } }))

    return disable as MenuItemType[];

})();

export default DISABLED